import { useRef } from "react";
import { MenuItem, Select, TextField, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

export const Duration = ({ value }: { value: number }) => {
    const hours = Math.floor(value / 60);
    const mins = value % 60;

    return (
        <>
            {Boolean(hours) && (
                <>
                    {hours}{" "}
                    <FormattedMessage
                        id="meetingLength.hours"
                        defaultMessage="{value, plural, one {hour} other {hours} }"
                        values={{ value: hours }}
                    />
                </>
            )}
            {Boolean(hours && mins) && <span style={{ paddingLeft: "0.3em" }} />}
            {Boolean(mins) && (
                <>
                    {mins}{" "}
                    <FormattedMessage
                        id="meetingLength.mins"
                        defaultMessage="{value, plural, one {minute} other {minutes} }"
                        values={{ value: mins }}
                    />
                </>
            )}
        </>
    );
};

type SimplifiedDurationFieldProps = {
    value: number;
    onChange: (val: number) => void;
    disabled?: boolean;
};

export const SimplifiedDurationField = ({ value, onChange, disabled }: SimplifiedDurationFieldProps) => {
    return (
        <Select value={value} size="small" onChange={(ev) => onChange(ev.target.value)} disabled={disabled}>
            {window.meetingLengthSelectOptions.map((v) => (
                <MenuItem value={v} key={v}>
                    <Duration value={v} />
                </MenuItem>
            ))}
        </Select>
    );
};

export const FreeDurationField = ({ value, onChange }: { value: number; onChange: (value: number) => void }) => {
    const hoursRef = useRef<HTMLInputElement>(null);
    const minsRef = useRef<HTMLInputElement>(null);

    return (
        <div style={{ display: "flex", alignItems: "center" }}>
            <TextField
                inputRef={hoursRef}
                value={Math.floor(value / 60)}
                size="small"
                type="number"
                style={{ width: 50 }}
                onChange={(ev) => {
                    onChange(parseInt(ev.target.value) * 60 + parseInt(minsRef.current.value));
                }}
                InputProps={{
                    inputProps: {
                        min: 0,
                        style: {
                            textAlign: "right",
                        },
                    },
                }}
            />
            <Typography style={{ marginLeft: 3, marginRight: "1em" }}>
                <FormattedMessage
                    id="meetingLength.hours"
                    defaultMessage="{value, plural, one {hour} other {hours} }"
                    values={{ value: Math.floor(value / 60) }}
                />
            </Typography>
            <TextField
                inputRef={minsRef}
                value={value % 60}
                type="number"
                size="small"
                style={{ width: 50 }}
                onChange={(ev) => {
                    onChange(parseInt(hoursRef.current.value) * 60 + parseInt(ev.target.value));
                }}
                InputProps={{
                    inputProps: {
                        min: 0,
                        max: 59,
                        style: {
                            textAlign: "right",
                        },
                    },
                }}
            />
            <Typography style={{ marginLeft: 3 }}>
                <FormattedMessage
                    id="meetingLength.mins"
                    defaultMessage="{value, plural, one {minute} other {minutes} }"
                    values={{ value: value % 60 }}
                />
            </Typography>
        </div>
    );
};
